import React from 'react';
import PropTypes from 'prop-types';
import alarmClock from 'assets/img/svg/alarm-clock.svg';

const NotificationToast = ({ onClick, title, subtitle, body }) => {
  NotificationToast.propTypes = {
    onClick: PropTypes.func.isRequired,
    title: PropTypes.oneOf([
      PropTypes.string,
      PropTypes.node,
      PropTypes.number
    ]),
    subtitle: PropTypes.oneOf([
      PropTypes.string,
      PropTypes.node,
      PropTypes.number
    ]),
    body: PropTypes.oneOf([
      PropTypes.string,
      PropTypes.node,
      PropTypes.number
    ])
  };

  return <div className='notification-toast-container' onClick={onClick}>
    <img className='alarm-clock-icon' src={alarmClock} />
    <div className='notification-body'>
      <span>{title}</span>
      <span>{subtitle}</span>
      <span>{body}</span>
    </div>
  </div>;
};

export default NotificationToast;
